// extracted by mini-css-extract-plugin
module.exports = {"wrap":"RichTextEditor_wrap__3H9X6","editor":"RichTextEditor_editor__m_mRs","has-focus":"RichTextEditor_has-focus__1FpvH"};